module.exports = __webpack_public_path__ + "img/teacher1.1e971233.png";